import React from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  metadata?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'compact' | 'hero';
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  metadata,
  icon,
  className = '',
  variant = 'default',
}) => {
  const titleSize = variant === 'compact'
    ? 'text-2xl sm:text-3xl'
    : 'text-3xl sm:text-4xl';

  return (
    <div className={`flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between ${className}`}>
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          {icon && (
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-50 text-primary-600 ring-1 ring-primary-100">
              {icon}
            </div>
          )}
          <h1 className={`${titleSize} font-extrabold tracking-tight leading-tight text-monday-text`}>
            {title}
          </h1>
        </div>
        {subtitle && (
          <p className="mt-1.5 max-w-3xl text-sm text-monday-text-muted">
            {subtitle}
          </p>
        )}
        {metadata && (
          <div className="mt-3 flex flex-wrap items-center gap-2 text-sm text-monday-text-muted">
            {metadata}
          </div>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2 sm:justify-end">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
